import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Queries from 'api/graphql/queries';
import { getAdminMinioCredentials } from '@api/graphql/types';

/**
 * Queries the Minio credentials from backend
 */
export async function getAdminMinio() {
    const response = await GraphQLClient.query<getAdminMinioCredentials>({
        query: Queries.getAdminMinioCredentials,
    });
    return response.data;
}


// WEBPACK FOOTER //
// ./src/utils/GraphQL.ts